module.exports = __webpack_public_path__ + "static/avatar_director@2x-5a3739147cbcb38f7ce1358a2ad69fa4.jpg";